module.exports = __webpack_public_path__ + "media/images/num1_ic-on-f95338ca4ee1a6e1efa22e97953258ea.svg";